module.exports = __webpack_public_path__ + "3fe9949799b6d2fdeb014fdc75f70216.png";